import React from 'react';
import { PointOfSaleContext } from '@olxbr/mojo-jojo/contexts';
import FeeHeader from './FeeHeaderContainer';
import FreeHeader from './FreeHeader';
import RedAlert from '../../../core/images/red-alert-triangle.svg';

const Header = () => (
  <PointOfSaleContext>
    {({
      contentData, posData, limitsData, adData,
    }) => (
      posData.limitExceeded ?
        <FeeHeader
          content={contentData}
          limits={limitsData}
          icon={(posData.standAlone) ? null : RedAlert}
        /> :
        <FreeHeader
          purchased={posData.alreadyBoughtProduct}
          content={contentData}
          limits={limitsData}
          type={posData.parentName}
          adName={adData.name}
        />
    )}
  </PointOfSaleContext>
);

export default Header;
